import React from 'react';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import {lazy} from '@aboutyou/lazy-imports';

export const Category = lazy(
  () => import('./Category.eager').then(mod => ({default: mod.Category})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
